// extracted by mini-css-extract-plugin
export default {"tableHeader":"Advance_tableHeader__bsVU4","tableCells":"Advance_tableCells__0s-Xu"};